export default {"src":"/_next/static/media/share-xs.aa9b5729.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};